import React from 'react'
import groupBy from 'lodash/groupBy'
import { Dictionary } from 'lodash'

export type AddressBookContact = {
  id: number
  internalNumber: string
  name: string
  number: string
  addressBookId: number
}

export type AddressBook = {
  id: number
  name: string
}

type State = {
  contacts: AddressBookContact[]
  contactsGrouped: Dictionary<AddressBookContact[]>
  addressBooks: AddressBook[]
}

export const AddressBookManagerContext = React.createContext<State>({
  contacts: [],
  contactsGrouped: {},
  addressBooks: [],
})

type Props = {
  contacts: AddressBookContact[]
  addressBooks: AddressBook[]
  children: React.ReactNode
}

const AddressBookManager: React.FC<Props> = ({
  contacts,
  addressBooks,
  children,
}) => {
  const contactsGrouped = groupBy(contacts, contact => contact.addressBookId)

  return (
    <AddressBookManagerContext.Provider
      value={{
        contacts,
        contactsGrouped,
        addressBooks,
      }}
    >
      {children}
    </AddressBookManagerContext.Provider>
  )
}

export default AddressBookManager
